<template>
  <div class="email-history-details-container margin-side">
      <div class="btn-back-wrapper">
        <div class="btn-back icon-back" @click="cancelClick"></div>
      </div>
      <div class="page-title h2-text">Email - Detailed View</div>
      <div>
        <EmailHistoryDetails :id="id" />
      </div>
    </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  // import emailTemplateConsts from '@/store/constants/emailTemplateType';
  // import consts from '../../_consts';
  import EmailHistoryDetails from '@/components/events/EmailHistoryDetails'

  export default {
    name: 'Email-History-Details-Page',
    components: {
      EmailHistoryDetails
    },
    data () {
      return {
        id: null,
        histories: [],
        eventId: null,
        isManageHistories: false
      };
    },
    filters: {
      filterRelatedEventsName: function (listRelatedEvents) {
        let result = '';
        listRelatedEvents.forEach((index, element) => {
        })
        return result;
      }
    },
    computed: {
      ...mapGetters({
        columnWidth: 'GETTER_GET_COLUMN_TABLE_EMAIL_HISTORIES'
      })
    },
    methods: {
      goToEventDetails (historyId) {
      },
      cancelClick () {
        if (this.eventId) {
          this.$router.push({name: 'EmailHistoriesManagement', params: {eventId: this.eventId}});
        } else {
          this.$router.push({name: 'ManagerDashboard'});
        }
      },
      ...mapActions({
        getDefaultEmailTemplate: 'ACTION_GET_DEFAULT_EMAIL_TEMPLATE',
        sendOnSiteContactEmail: 'ACTION_SEND_ON_SITE_CONTACT_EMAIL'
      })
    },
    mounted () {
      if (this.$route.params && this.$route.params.id) {
        this.id = this.$route.params.id;
        this.eventId = this.$route.params.eventId;
      }
    }
};
</script>

<style lang="less">
  @import '../../styles/variables.less';
</style>



// WEBPACK FOOTER //
// EmailHistoryDetails.vue?28c212c7